/*
 * Phones: a "back to top" button in the bottom-right that fades in once the
 * visitor has scrolled down, and scrolls smoothly to the top when tapped.
 *
 * The markup lives in layout/theme.liquid rather than in the header section:
 * the button is position: fixed, and .section-header is transformed when the
 * header hides on scroll. A transformed ancestor becomes the containing block
 * for fixed descendants, which would anchor the button to the header (top of
 * the screen) instead of the viewport.
 *
 * Paired with the .back-to-top rules in component-search.css.
 */
(function () {
  var SHOW_AFTER = 400; // px scrolled before the button appears

  function init() {
    var btn = document.querySelector('.back-to-top');
    if (!btn) return;

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    var ticking = false;

    function update() {
      ticking = false;
      var scrolled = window.pageYOffset || document.documentElement.scrollTop;
      btn.classList.toggle('back-to-top--visible', scrolled > SHOW_AFTER);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true },
    );

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
